module.exports = __webpack_public_path__ + "static/19-ff9f7a28b95a42cb4ab8bdc69c0773ac.png";